import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import OverleafAPI from "../../../../../../../services/overleaf";
import { DeckData } from "./types";
import {
  FETCH_DECKS_PREFIX,
  FETCH_DECK_PREFIX,
  SET_SELECTED_DECK,
  CREATE_DECK_PREFIX,
  UPDATE_DECK_PREFIX,
  DELETE_DECK_PREFIX,
} from "./types";
import { exceptionHandler } from "../utils";
import { normalize } from "normalizr";
import { DeckSchema } from "../resources";
import { NormalizedEntity } from "../types";

const overleafAPI = new OverleafAPI();

const normalizeDeck = ({ deck }) => {
  return normalize(deck, DeckSchema);
};

const normalizeDecks = ({ decks }) => {
  return normalize(decks, [DeckSchema]);
};

export const fetchDecks = createAsyncThunk(
  FETCH_DECKS_PREFIX,
  async (meta: any, { rejectWithValue }): Promise<NormalizedEntity<any>> => {
    const instance = await overleafAPI.getInstance();
    return instance.Decks.all(meta).then(
      normalizeDecks,
      exceptionHandler.bind(null, rejectWithValue)
    );
  }
);

export const fetchDeck = createAsyncThunk(
  FETCH_DECK_PREFIX,
  async (id: string, { rejectWithValue }): Promise<NormalizedEntity<any>> => {
    const instance = await overleafAPI.getInstance();
    return instance.Decks.one(id).then(
      normalizeDeck,
      exceptionHandler.bind(null, rejectWithValue)
    );
  }
);

export const createDeck = createAsyncThunk(
  CREATE_DECK_PREFIX,
  async (
    data: DeckData,
    { rejectWithValue }
  ): Promise<NormalizedEntity<any>> => {
    const instance = await overleafAPI.getInstance();
    return instance.Decks.create(data).then(
      normalizeDeck,
      exceptionHandler.bind(null, rejectWithValue)
    );
  }
);

export const updateDeck = createAsyncThunk(
  UPDATE_DECK_PREFIX,
  async (
    data: DeckData,
    { rejectWithValue }
  ): Promise<NormalizedEntity<any>> => {
    const instance = await overleafAPI.getInstance();
    return instance.Decks.update(data.uuid, data).then(
      normalizeDeck,
      exceptionHandler.bind(null, rejectWithValue)
    );
  }
);

export const deleteDeck = createAsyncThunk(
  DELETE_DECK_PREFIX,
  async (id: string, { rejectWithValue }): Promise<NormalizedEntity<any>> => {
    const instance = await overleafAPI.getInstance();
    return instance.Decks.delete(id).catch(
      exceptionHandler.bind(null, rejectWithValue)
    );
  }
);

export const setSelectedDeck = createAction<string>(SET_SELECTED_DECK);
